// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ constants
const {
    CM_INTERVENER_ITEM_TITULAR,
    CM_INTERVENER_ITEM_AUTORIZADO,
    CM_INTERVENER_ITEM_REP,
    CM_INTERVENER_ITEM_ADMIN,
    CM_INTERVENER_ITEM_APODERADO,
} = require('wealth-cm/constants/constants');

function getTranslationIntervenerFromType(type) {
    switch (type) {
        case CM_INTERVENER_ITEM_TITULAR:
            return formatText('brokerIntevenerItem-holder');
        case CM_INTERVENER_ITEM_AUTORIZADO:
            return formatText('brokerIntevenerItem-authorized');
        case CM_INTERVENER_ITEM_REP:
            return formatText('brokerIntevenerItem-legalRepresentative');
        case CM_INTERVENER_ITEM_ADMIN:
            return formatText('brokerIntevenerItem-administrator');
        case CM_INTERVENER_ITEM_APODERADO:
            return formatText('brokerIntevenerItem-empowered');
        default:
            return;
    }
}

module.exports = { getTranslationIntervenerFromType };
